import { post, type RequestOptions } from "~/common/request"
import {
  getUploadedResourceKind,
  type UploadedResource,
} from "~/common/media/uploadedResources"

const getMaterialType = (
  resource: Pick<UploadedResource, "name" | "type" | "url">,
): API.Material.UserMaterialType => {
  return getUploadedResourceKind({
    ...resource,
    uploadedAt: Date.now(),
  })
}

export const createMaterial = (
  params: API.Material.CreateUserMaterialParams,
  signal?: AbortSignal,
) => {
  return post<API.Material.UserMaterial>("/api/material/create", params, {
    signal,
  })
}

export const listMaterials = (params: API.Material.UserMaterialListParams) => {
  return post<API.Material.UserMaterialListResponse>(
    "/api/material/list",
    params,
  )
}

export const analyzeProductImage = (
  params: API.Material.AnalyzeProductImageParams,
  options?: RequestOptions,
) => {
  return post<API.Material.AnalyzeProductImageTaskId>(
    "/api/material/analyze_image",
    params,
    options,
  )
}

export const getAnalyzeImageResult = (
  params: API.Material.AnalyzeTaskIdParams,
  options?: RequestOptions,
) => {
  return post<API.Material.ProductImageAnalysisResult>(
    "/api/material/analyze_image_result",
    params,
    options,
  )
}

export const createMaterialFromResource = (
  resource: Pick<UploadedResource, "name" | "size" | "type" | "url">,
  signal?: AbortSignal,
) => {
  return createMaterial(
    {
      material_url: resource.url,
      name: resource.name || "未命名资源",
      size: resource.size || 1,
      material_type: getMaterialType(resource),
    },
    signal,
  )
}

export const getResourceFromMaterial = (
  material: API.Material.UserMaterial,
): UploadedResource => {
  return {
    id: material.id,
    url: material.material_url,
    name: material.name,
    size: material.size,
    type: material.material_type,
    uploadedAt: material.created_t
      ? new Date(material.created_t).getTime()
      : Date.now(),
  }
}
